import { ARTICLES, COURSES, QUIZ_BANK } from "./data.js";
import { useCore } from "./hooks/useCore.js";
import { buildNavView } from "./screens/navView.js";
import { buildSearchView } from "./screens/searchView.js";
import { buildHomeView } from "./screens/homeView.js";
import { buildArticleView } from "./screens/articleView.js";
import { buildCourseView } from "./screens/courseView.js";
import { buildToolsView } from "./screens/toolsView.js";
import { buildTshootView } from "./screens/tshootView.js";
import { buildXlateView } from "./screens/xlateView.js";
import { buildCompareView } from "./screens/compareView.js";
import { buildDiagramsView } from "./screens/diagramsView.js";
import { buildGraphView } from "./screens/graphView.js";
import { buildReviseView } from "./screens/reviseView.js";
import { buildCertifView } from "./screens/certifView.js";
import { buildIndexView } from "./screens/indexView.js";
import { buildProfileView } from "./screens/profileView.js";

// Composes the whole `v` view-model handed to <App/>. State, effects and
// Supabase sync live in useCore(); each screen's own presentation logic
// lives in its own file under src/screens/ as a plain `build*View(ctx)`
// function. This file's job is only to compute the handful of values that
// more than one screen needs (current article/course/module, the shared
// quiz-engine state) and hand every builder the same `ctx`.
export function useNetdoc() {
  const core = useCore();
  const { s } = core;

  // ---- fiche courante ----
  const art = ARTICLES.find((a) => a.id === s.articleId) || ARTICLES[0];
  const idx = ARTICLES.indexOf(art);
  const all = core.results();
  const res = all.slice(0, 6);
  const hovered = res.find((a) => a.id === s.hoverId) || res[0] || art;

  // ---- cours / module courant ----
  const course = COURSES.find((c) => c.id === s.courseId) || COURSES[0];
  const moduleIdx = Math.min(s.moduleIdx, course.modules.length - 1);
  const curModule = course.modules[moduleIdx];
  const lessonsData = curModule.lessons;
  const isLessonDone = (l) => !!s.done[core.doneKey(course.id, moduleIdx, l.n)];
  const doneCount = lessonsData.filter(isLessonDone).length;
  const firstTodo = lessonsData.find((l) => !isLessonDone(l));
  const curDomainId = course.id + ":" + moduleIdx;

  // ---- moteur de quiz partagé entre le module de cours et la pratique
  // Certif (quizDomainId prime sur le domaine du module actuellement ouvert
  // quand une session Certif a été lancée depuis practiceDomain) ----
  const activeQuizDomain = s.quizDomainId || curDomainId;
  const domainQuestions = QUIZ_BANK.filter((q) => q.domainId === activeQuizDomain);
  const quizQ = domainQuestions[Math.min(s.quizIdx, domainQuestions.length - 1)];
  const quizFinished = s.quizDomainId && s.quizIdx >= domainQuestions.length;

  const ctx = {
    ...core,
    art, idx, all, res, hovered,
    course, moduleIdx, curModule, lessonsData, isLessonDone, doneCount, firstTodo, curDomainId,
    activeQuizDomain, domainQuestions, quizQ, quizFinished,
  };

  return {
    ...buildNavView(ctx),
    ...buildSearchView(ctx),
    ...buildHomeView(ctx),
    ...buildArticleView(ctx),
    ...buildCourseView(ctx),
    ...buildToolsView(ctx),
    ...buildTshootView(ctx),
    ...buildXlateView(ctx),
    ...buildCompareView(ctx),
    ...buildDiagramsView(ctx),
    ...buildGraphView(ctx),
    ...buildReviseView(ctx),
    ...buildCertifView(ctx),
    ...buildIndexView(ctx),
    ...buildProfileView(ctx),
  };
}
